var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                { attrs: { inline: "", size: "small" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "频道名称" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "400px" },
                          attrs: {
                            placeholder: "频道名称",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "name", $$v)
                            },
                            expression: "listPram.name",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:store:label:save"],
                      expression: "['admin:store:label:save']",
                    },
                  ],
                  staticClass: "mr10",
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handlerOpenEdit({})
                    },
                  },
                },
                [_vm._v("新增频道")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "id", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": true,
                  prop: "channelName",
                  label: "频道名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": true,
                  prop: "remark",
                  label: "备注",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "spuNum",
                  label: "绑定SPU数量",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuNum",
                  label: "绑定SKU数量",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": true,
                            "inactive-value": false,
                            "active-text": "启用",
                            "inactive-text": "禁用",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onchangeIsShow(
                                scope.row,
                                "status",
                                "changeState"
                              )
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c("el-table-column", {
                    attrs: {
                      prop: "isOfflinePayment",
                      label: "线下支付",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onchangeIsShow(
                                      scope.row,
                                      "isOfflinePayment",
                                      "changeOpState"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.isOfflinePayment,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isOfflinePayment", $$v)
                                  },
                                  expression: "scope.row.isOfflinePayment",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3080644606
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c("el-table-column", {
                    attrs: {
                      prop: "isFilm",
                      label: "电影支付",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onchangeIsShow(
                                      scope.row,
                                      "isFilm",
                                      "changeFilmState"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.isFilm,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isFilm", $$v)
                                  },
                                  expression: "scope.row.isFilm",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      525192431
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c("el-table-column", {
                    attrs: {
                      prop: "isMeal",
                      label: "点餐支付",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onchangeIsShow(
                                      scope.row,
                                      "isMeal",
                                      "changeMealState"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.isMeal,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isMeal", $$v)
                                  },
                                  expression: "scope.row.isMeal",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2052765380
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c("el-table-column", {
                    attrs: {
                      prop: "isCake",
                      label: "蛋糕板块",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onchangeIsShow(
                                      scope.row,
                                      "isCake",
                                      "changeCakeState"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.isCake,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isCake", $$v)
                                  },
                                  expression: "scope.row.isCake",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3107166765
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "isOffline",
                  label: "核销支付",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": true,
                            "inactive-value": false,
                            "active-text": "开启",
                            "inactive-text": "关闭",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onchangeIsShow(
                                scope.row,
                                "isOffline",
                                "changeOfflineState"
                              )
                            },
                          },
                          model: {
                            value: scope.row.isOffline,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "isOffline", $$v)
                            },
                            expression: "scope.row.isOffline",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c("el-table-column", {
                    attrs: {
                      prop: "isSjt",
                      label: "三甲通",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onchangeIsShow(
                                      scope.row,
                                      "isSjt",
                                      "changeSjtState"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.isSjt,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isSjt", $$v)
                                  },
                                  expression: "scope.row.isSjt",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3924430636
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c("el-table-column", {
                    attrs: {
                      prop: "isDental",
                      label: "华西口腔",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onchangeIsShow(
                                      scope.row,
                                      "isDental",
                                      "changeDentalState"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.isDental,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isDental", $$v)
                                  },
                                  expression: "scope.row.isDental",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      134155415
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c("el-table-column", {
                    attrs: {
                      prop: "isParking",
                      label: "三江停车",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onchangeIsShow(
                                      scope.row,
                                      "isParking",
                                      "changeParkingState"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.isParking,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isParking", $$v)
                                  },
                                  expression: "scope.row.isParking",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      567205545
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c("el-table-column", {
                    attrs: {
                      prop: "isStation",
                      label: "三江油",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onchangeIsShow(
                                      scope.row,
                                      "isStation",
                                      "changeStationState"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.isStation,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isStation", $$v)
                                  },
                                  expression: "scope.row.isStation",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4104662235
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c("el-table-column", {
                    attrs: {
                      prop: "isWater",
                      label: "三江水",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onchangeIsShow(
                                      scope.row,
                                      "isWater",
                                      "changeWaterState"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.isWater,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isWater", $$v)
                                  },
                                  expression: "scope.row.isWater",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      699623412
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c("el-table-column", {
                    attrs: {
                      prop: "isMerchant",
                      label: "多商户支付",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onchangeIsShow(
                                      scope.row,
                                      "isMerchant",
                                      "changeMerchantState"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.isMerchant,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isMerchant", $$v)
                                  },
                                  expression: "scope.row.isMerchant",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4121479307
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c("el-table-column", {
                    attrs: {
                      prop: "isLypJd",
                      label: "来一票京东（来一票）",
                      "min-width": "160",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onchangeIsShow(
                                      scope.row,
                                      "isLypJd",
                                      "changeLypJdStatus"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.isLypJd,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isLypJd", $$v)
                                  },
                                  expression: "scope.row.isLypJd",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3802880297
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c("el-table-column", {
                    attrs: {
                      prop: "isLypSm",
                      label: "山姆（来一票）",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onchangeIsShow(
                                      scope.row,
                                      "isLypSm",
                                      "changeLypSmStatus"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.isLypSm,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isLypSm", $$v)
                                  },
                                  expression: "scope.row.isLypSm",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3543267673
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "200",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:channel:edit"],
                                expression: "['admin:channel:edit']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:channel:delete"],
                                expression: "['admin:channel:delete']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:channel:bindList"],
                                expression: "['admin:channel:bindList']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerGoodsChannel(scope.row)
                              },
                            },
                          },
                          [_vm._v("商品列表\n            ")]
                        ),
                        _vm._v(" "),
                        scope.row.isMerchant
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:channel:bindMerchantStoreList",
                                    ],
                                    expression:
                                      "['admin:channel:bindMerchantStoreList']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addMerchantStore(scope.row)
                                  },
                                },
                              },
                              [_vm._v("绑定多商户店铺\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:channel:addBind"],
                                expression: "['admin:channel:addBind']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.addProducts(scope.row)
                              },
                            },
                          },
                          [_vm._v("添加绑定\n            ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditStorechannel", {
        ref: "EditStorechannelRef",
        attrs: { miniProgramCustomer: _vm.miniProgramCustomer },
        on: { doRefresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("ChannelGoods", {
        ref: "ChannelGoodsRef",
        on: { doRefresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("BindChannel", {
        ref: "BindChannelRef",
        attrs: { miniProgramCustomer: _vm.miniProgramCustomer },
        on: { doRefresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("BindMerchantStore", {
        ref: "BindMerchantStore",
        attrs: {
          miniProgramCustomer: _vm.miniProgramCustomer,
          show: _vm.drawerVisible,
        },
        on: {
          doRefresh: _vm.handerSearch,
          "update:show": function ($event) {
            _vm.drawerVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }